module.exports = __webpack_public_path__ + "static/resume-0394c7aa53fc13d369868aeeb280def4.png";